module.exports = __webpack_public_path__ + "static/media/Icon_Case_Studies_White.a2b723bf.png";